import React, { useState } from "react";
import "./HomeContent.css";
import Button from "@mui/material/Button";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import mailData from "../Data/mailData.js";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 200) : text}
      <span onClick={toggleReadMore} className="read-or-hide">
        {isReadMore ? " ...read more" : " show less"}
      </span>
    </p>
  );
};

function HomeContent() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  const responsive2 = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  return (
    <>
      {/* <Breadcrumb/> */}
      <div className="main-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/Home/LKM-Home-QA-Banner.png"}
          alt="Banner"
          className="banner-img"
        />
        <div className="banner-content">
          <h1>Quality Assurance</h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>
      <div className="main-container">
        {/* section 1  */}
        <div className="quality-container">
          <div className="quality-wrap">
            <div className="quality-row1">
              <div className="videoContainer">
                <video
                  className="about-us-video about-us-video-margin"
                  poster={process.env.PUBLIC_URL + "/images/Home/QA-site.png"}
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Home/QA_site video_Updated.mp4"
                  }
                  controls
                ></video>
                <p>QA Site Navigation Video</p>
              </div>
            </div>

            <div className="quality-row2">
              <h2>Quality Assurance</h2>
              <p>
                Quality assurance focuses on providing confidence that quality
                requirements will be fulfilled and includes all the planned and
                systematic activities implemented in a quality management system
                so that quality requirements for a product or service will be
                fulfilled.
              </p>
            </div>
          </div>
        </div>

        {/* section 2  */}
        <div className="lead-container">
          <div className="lead-wrap">
            <h2>Leadership Message</h2>

            <div className="">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Ambrish.png"}
                className="leader_card"
              />
            </div>
            <div className="leader_card_div">
              <div className="leader_card_each">
                <div className="lead-quotes">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Home/double-quote1.png"
                    }
                    alt="double-quote"
                    className="lead-quote1"
                  />
                </div>
                <div className="leader_content_wrapper">
                  <p>
                    L&TT is the{" "}
                    <span className="highlightColor">
                      strategic engine for ATCI, that helps with growth and
                      change of the business
                    </span>
                    , with plethora of our thoughtfully crafted large programs
                    for talent creation and transformation. The work that we do
                    at L&TT is complex, at scale, and extremely dynamic,
                    covering a large spectrum of areas. We also have to{" "}
                    <span className="highlightColor">
                      deal constantly with the change dynamics
                    </span>
                    , such as - technology changes that are rapid, changing
                    client needs, changing employee aspirations, changing
                    business needs, changing ways of working/learning, etc.
                  </p>
                  <p>
                    {" "}
                    As we work in such an environment, the following become very
                    critical for us to succeed and evoke trust of all our
                    stakeholders -
                    <span className="highlightColor">
                      creating and delivering our services with utmost
                      effectiveness, producing greatest impact, delivering
                      impeccable value, and delighting our learners
                    </span>{" "}
                    with thoughtfully designed learning experiences.
                  </p>
                  <p>
                    {" "}
                    In order to achieve these tall goals, the{" "}
                    <span className="highlightColor">
                      robustness we build in our quality processes will help our
                      work to be systematic, predictable, repeatable, and
                      reliable.
                    </span>{" "}
                    It is our endeavor to build, enhance, and adhere to these
                    processes to achieve excellence in whatever we do.{" "}
                  </p>
                  <p>
                    {" "}
                    I urge and request all of you to not only make best use of
                    what is available here, but also actively contribute back to
                    enrich it constantly.
                  </p>
                </div>
                <div className="leader_content_wrapper_subsec">
                  <p className="subsec_header">Ambrish Rastogi</p>
                  <p className="subsec_para">
                    Lead - Learning and Leadership Development, ATC-GN
                  </p>
                </div>
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/Home/double-quote2.png"
                  }
                  alt="double-quote"
                  className="lead-quote2"
                />
              </div>
            </div>
          </div>
        </div>

        {/* section 3  */}
        <div className="messages-container">
          <div className="messages-wrap">
            <h2>Messages from Leads</h2>
            <div className="messages-row">
              <div className="messages-content">
                <img
                  src="/images/Home/Leads/PraveenRajaram.png"
                  alt="profile-picture"
                />
                <div className="messages-box">
                  <h3>Praveen Rajaram</h3>
                  <h5>Enterprise and Industry Technologies</h5>
                  {/* <ReadMore> */}
                  <p>
                    {" "}
                    The importance of QA cannot be overstated. By prioritizing
                    QA, we ensure that our{" "}
                    <b>
                      learners and stakeholders receive the best possible
                      experience
                    </b>
                    , and that our{" "}
                    <b>
                      Learning function continues to be a valuable and strategic
                      resource
                    </b>{" "}
                    for our organization.
                  </p>
                  {/* </ReadMore> */}
                </div>
              </div>
              <div className="messages-content">
                <img
                  src="/images/Home/Leads/AnirudhGoel.png"
                  alt="profile-picture"
                />
                <div className="messages-box">
                  <h3>Anirudh Goel</h3>
                  <h5>Strategic Initiatives, AI, Innovation, Custom Engg</h5>
                  {/* <ReadMore> */}
                  <p>
                    Quality as I see it has two dimensions, the process part of
                    it which is about{" "}
                    <b>
                      consistency and discipline as we create outcomes be it
                      deliverables or learning experiences
                    </b>
                    , and the second dimension is about{" "}
                    <b>
                      aligning with customer expectations which keep changing
                      from time to time.
                    </b>{" "}
                    We need to ensure that we address both these aspects of
                    quality in the work we do.
                  </p>
                  {/* </ReadMore> */}
                </div>
              </div>

              <div className="messages-content">
                <img
                  src="/images/Home/Leads/GajendraMallik.png"
                  alt="profile-picture"
                />
                <div className="messages-box">
                  <h3>Gajendra Mallik</h3>
                  <h5>Delivery, Security, IE, Quality</h5>
                  {/* <ReadMore> */}
                  <p>
                    The quality as in learning function could be processes &
                    techniques adapted to achieve learning excellence, thereby
                    addressing key aspects like{" "}
                    <b>
                      healthy learners, encouraging atmosphere, relevant
                      curriculums, effective instruction, and outcomes.
                    </b>
                  </p>
                  {/* </ReadMore> */}
                </div>
              </div>
              <div className="messages-content">
                <img
                  src="/images/Home/Leads/Mukhvinder.png"
                  alt="profile-picture"
                />
                <div className="messages-box">
                  <h3>Mukhvinder Bains</h3>
                  <h5>
                    Learning Operations Lead - Learning Infrastructure, Vendor
                    Management, Information Resource Center, ATC GN
                  </h5>
                  {/* <ReadMore> */}
                  <p>
                    Implement and maintain a clear, systematic and robust
                    framework for operations to achieve consistency and
                    improvements.{" "}
                    <b>
                      Tracking of outcomes and updating the processes to meet
                      the dynamic changes
                    </b>{" "}
                    evolving out of the organization business models from time
                    to time. High standards of operations are essential to an
                    learning organization brining out{" "}
                    <b>
                      high quality learning and employee outcomes, leading to
                      transform the talents with NextGen Skill.
                    </b>
                  </p>
                  {/* </ReadMore> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="learningpath_section">
          <div className="learningpath_para">
            <h2>L&TT QA Charter</h2>
            <p>
              Applicable to L&TT as a function, including different work
              streams, with focus on defining the processes, implementation,
              formal reviews/audits, measurement and reporting on continual
              basis.
            </p>
          </div>
        </div>
      </div>

      <div className="training_container">
        <h2>Key Phases of Learning Lifecycle</h2>
        <div className="training_card">
          {/* <div className='training_card_img_wrapper'><img src={process.env.PUBLIC_URL + "/images/Home/Training Phases.png"} alt="training" className='training_img'/>
                    
                    <div className='training_card_cont_wrapper'>
                        <ul>
                            <li>Activities</li>
                        </ul>
                    </div>
                    </div> */}
          <div className="training_card_img_wrapper">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Learning Need Analysis.png"
              }
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>Business driven demand analysis</li>
                <li>Adhoc request</li>
              </ul>
            </div>
          </div>
          <div className="training_card_img_wrapper">
            <img
              src={process.env.PUBLIC_URL + "/images/Home/Learning Plan.png"}
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>New course identification(online/vitual/blended)</li>
                <li>Baselining courses</li>
                <li>Employee coverage plan</li>
              </ul>
            </div>
          </div>
          <div className="training_card_img_wrapper">
            <img
              src={process.env.PUBLIC_URL + "/images/Home/Design.png"}
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>Curriculum development</li>
                <li>Review signoff</li>
              </ul>
            </div>
          </div>
          <div className="training_card_img_wrapper">
            <img
              src={process.env.PUBLIC_URL + "/images/Home/Execution.png"}
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>Session delivery</li>
                <li>Monitoring & tracking</li>
                <li>Feedback and reporting</li>
              </ul>
            </div>
          </div>
          <div className="training_card_img_wrapper">
            <img
              src={
                process.env.PUBLIC_URL + "/images/Home/Feedback Analysis.png"
              }
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>Qualitative & quantitative</li>
                <li>Training effectiveness</li>
              </ul>
            </div>
          </div>
          <div className="training_card_img_wrapper">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Continuous-improvement.png"
              }
              alt="training"
              className="training_img"
            />
            <div className="training_card_cont_wrapper">
              <ul>
                <li>Service reviews</li>
                <li>Process evaluation</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Hanging menu  */}
      <div className="icons-container">
        <div className="icons-wrap">
          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"}
                  alt="Mailicon"
                  className="group-img mailIcon"
                  id="icon-chat"
                />
                <a
                  className="contact-us"
                  target="_blank"
                  href={`mailto: ${mailData.dellearningframework}`}
                >
                  <span className="menu-text">Write to us</span>
                </a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="link_container_below">
        <div className="link_cont_wrap">
          <div>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Acc_GT_Dimensional_RGB.png"
              }
              alt="AccentureIcon"
              className="link_accenture_logo"
            />
          </div>
          <div className="link_text_cont">
            <span>
              For any queries or support, you may reach out to
              <a
                className="link_anchor"
                href={`mailto:${mailData.qualityassurance}`}
                target="_blank"
              >
                {" "}
                {mailData.qualityassurance}{" "}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeContent;
